// extracted by mini-css-extract-plugin
export default {"container":"SentEmailRecipients_container__3M93Y","to":"SentEmailRecipients_to__G95Ra","recipient":"SentEmailRecipients_recipient__kYCMO","email":"SentEmailRecipients_email__LZpnz"};